import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { set_token } from "redux/actions/auth";

const Home = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(set_token());
  }, []); // eslint-disable-line

  return <div className="home"></div>;
};

export default Home;
